import { c as _c } from "react/compiler-runtime";
import { useNotifications } from '@newfront-insurance/next-notifications';
import useMutation from 'use-mutation';
import { usePolicyApi } from '../api/policy-api';
import type { RenewPolicyAsIsBody, RenewPolicyAsIsResponse } from '../bff/types';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
export function useRenewPolicyAsIs() {
  const $ = _c(4);
  const policyApi = usePolicyApi();
  const notifications = useNotifications();
  let t0;
  if ($[0] !== policyApi) {
    t0 = t1 => {
      const {
        body
      } = t1;
      return policyApi.renewAsIs(body);
    };
    $[0] = policyApi;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== notifications) {
    t1 = {
      onSuccess(t2) {
        const {
          data
        } = t2;
        if (!data) {
          return;
        }
        notifications.add({
          title: "Policy renewed successfully...",
          type: "success"
        });
      },
      throwOnFailure: true
    };
    $[2] = notifications;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return useMutation(t0, t1);
}